// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3F-kQ","col":"styles_col__2ilIE"};